var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavbarSapflow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 78.34 39.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 34.79,
    y1: 28.55,
    x2: 40.44,
    y2: 28.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 18.68,
    y1: 10.25,
    x2: 24.33,
    y2: 10.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.97,
    y1: 10.25,
    x2: 14.53,
    y2: 10.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 10.25,
    y1: 14.53,
    x2: 10.25,
    y2: 5.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 51.83,
    y1: 28.55,
    x2: 59.84,
    y2: 28.55
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "35.33 10.25 45.77 10.25 45.77 23.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m33.88,6.18v8.13h-8.13V6.18h8.13m2-2h-12.13v12.13h12.13V4.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m33.88,24.49v8.13h-8.13v-8.13h8.13m2-2h-12.13v12.13h12.13v-12.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m49.83,24.49v8.13h-8.13v-8.13h8.13m2-2h-12.13v12.13h12.13v-12.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m68.09,20.57c4.55,0,8.25,3.7,8.25,8.25s-3.7,8.25-8.25,8.25-8.25-3.7-8.25-8.25,3.7-8.25,8.25-8.25m0-2c-5.66,0-10.25,4.59-10.25,10.25s4.59,10.25,10.25,10.25,10.25-4.59,10.25-10.25-4.59-10.25-10.25-10.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.25,2c4.55,0,8.25,3.7,8.25,8.25s-3.7,8.25-8.25,8.25S2,14.79,2,10.25,5.7,2,10.25,2m0-2C4.59,0,0,4.59,0,10.25s4.59,10.25,10.25,10.25,10.25-4.59,10.25-10.25S15.91,0,10.25,0h0Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "63.7 29.21 66.37 31.87 72.48 25.76"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarSapflow);
export default __webpack_public_path__ + "static/media/navbar-sapflow.ae1de526eba42a2bfefbd9769ef72c3e.svg";
export { ForwardRef as ReactComponent };